<template>
  <div class="progress">
    <div class="progress-track"/>
    <div class="progress-bar-container">
      <div class="progress-bar" :style="{
      width: currentProgress
    }"/>
    </div>
  </div>
</template>

<script setup lang="ts">
import {computed} from "vue";

const props = defineProps({
  progress: {
    type: Number,
    required: true,
  },
  active: {
    type: Boolean,
    default: false,
  }
});

const currentProgress = computed(() => {
  const progress = Math.max(props.active ? 5 : 0, props.progress * 100);

  return `${progress}%`;
});

</script>

<style scoped lang="scss">
.progress {
  padding: 1px 24px;
  width: 100%;
  max-width: 654px;
  position: absolute;
  bottom: 50px;
  left: 50%;
  transform: translateX(-50%);
}

.progress-track {
  border-radius: 999px;
  opacity: 0.2;
  background: var(--iqos-turquoise, #00D1D2);
  width: 100%;
  height: 6px;
}

.progress-bar-container {
  position: absolute;
  top: 0;
  left: 24px;
  bottom: 0;
  right: 24px;
}
.progress-bar {
  height: 100%;

  border-radius: 999px;
  background: var(--iqos-yellow, #FC0);
  /* answer-shadow */
  box-shadow: 4px 0px 4px 0px rgba(0, 0, 0, 0.20), 0px 0px 6px 1px rgba(255, 230, 71, 0.30), 0px 0px 26px 2px rgba(129, 202, 210, 0.20);

  transition: width .8s ease-out;
}
</style>
